import { Slot } from "expo-router";

import { MainPageWrapper } from "~/components/layout/layout";

export default function Layout() {
  return (
    <MainPageWrapper>
      <Slot />
    </MainPageWrapper>
  );
}
